"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareRequest = exports.processError = exports.processResponse = exports.ResponseHelpers = void 0;
const lodash_1 = require("lodash");
//TODO: add unit tests
exports.ResponseHelpers = {
    isStatusOk(status) {
        return status >= 200 && status <= 299;
    },
    isClientError(status) {
        return status >= 400 && status <= 499;
    },
    isServerError(status) {
        return status >= 500 && status <= 599;
    },
    isAborted(response) {
        return response.status === 0 && !response.statusText;
    },
};
/**
 * Process response data to only return what is needed by the application.
 */
const processResponse = (response) => {
    return {
        status: response.status,
        statusText: response.statusText,
        ok: true,
        aborted: exports.ResponseHelpers.isAborted(response),
        body: response.data,
    };
};
exports.processResponse = processResponse;
/**
 * Extend original response error to include properties expected by the application
 */
const processError = (originalError) => {
    originalError.body = (0, lodash_1.get)(originalError, 'response.data', {});
    originalError.status = (0, lodash_1.get)(originalError, 'response.status', 0);
    originalError.statusText = (0, lodash_1.get)(originalError, 'response.statusText', '');
    originalError.ok = false;
    throw originalError;
};
exports.processError = processError;
/**
 * Map properties passed by the application to properties
 * expected by axios.
 */
const prepareRequest = (options) => {
    var _a, _b;
    const method = (0, lodash_1.get)(options, 'method', 'get').toLowerCase();
    const isGetRequest = method === 'get';
    const data = isGetRequest ? null : options.params;
    const params = isGetRequest ? options.params : null;
    return {
        // Complete, absolute or relative URI where we will send the request
        url: options.path,
        // HTTP method. GET if no method is provided
        method,
        // URL parameters to be sent with a GET request, aka querystring params.
        // Must be a plain object or a URLSearchParams object
        params,
        // The data to be sent as the request body.
        // Only applicable for request methods 'PUT', 'POST', and 'PATCH'
        data,
        // Custom headers to send with the request
        headers: Object.assign({}, options.headers),
        // Number of milliseconds before the request times out.
        // If the request takes longer than `timeout`, the request will be aborted.
        timeout: (_a = options.timeout) !== null && _a !== void 0 ? _a : 0,
        // Only 2XX and 3XX status code responses are valid
        validateStatus(status) {
            return status >= 200 && status < 400;
        },
        withCredentials: (_b = options.withCredentials) !== null && _b !== void 0 ? _b : false,
    };
};
exports.prepareRequest = prepareRequest;
//# sourceMappingURL=helpers.js.map